/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch } from 'react-redux';
import { clearBrigades } from '../redux/actions/brigades.action';
import { clearDevices } from '../redux/actions/devices.action';
import { clearUipps } from '../redux/actions/uipps.action';
import { useEffect } from 'react';
import { updateSortData } from '../redux/actions/sortData.action';
import { clearKuobzes } from '../redux/actions/kuobz.action';
import { saveLastQuery } from '../redux/actions/lastQuery.action';
import { clearArchive } from '../redux/actions/archive.action';

const useClearStates = (location) => {
  const dispatch = useDispatch();
  // Creation of states to clear with clear actions
  useEffect(() => {
    dispatch(updateSortData({}));
    dispatch(saveLastQuery('?limit=50&offset=0'));
    const statesToClear = {
      devices: clearDevices,
      brigades: clearBrigades,
      uipps: clearUipps,
      archive: clearArchive,
      kuobz: clearKuobzes,
    };
    Object.keys(statesToClear).forEach((state) => {
      if (state !== location.slice(1)) {
        dispatch(statesToClear[state]());
      }
    });
  }, [location]);
};
export default useClearStates;
